import axios from '@/plugins/axios'

export default {
  login(email, password) {
    return axios.post('login', {
      email: email,
      password: password
    }).then(response => {
      return response.data
    })
  },
  fetchOwnData() {
    return axios.get('auth/me').then(response => {
      return response.data
    })
  }
}
